// Track events
export const SegmentEvents = {
  accounting: {
    externalVatRatesMissing: 'xxx-sales-externalvat-missing',
    vatErrorUserSide: 'xxx-sales-vat error user side',
    invoiceApprovalFailedVatRateError: 'xxx-sales-Invoice Approval Failed (VAT Rate Error)',
  },
  common: {
    signedIn: 'Signed In',
    signedOut: 'Signed Out',
    dashboardView: 'Dashboard Viewed (Client)',
  },
  company: {
    addVatRate: 'xxx - sales - add vat rate clicked',
  },
  customer: {
    add: 'Contact Created (Client)',
    delete: 'Contact Deleted (Client)',
    edit: 'Contact Updated (Client)',
    contactCreateModalChanged: 'xxx-signe-contact-create-modal-changed',
  },
  dashboard: {
    accountingBannerClicked: 'xxx - iam - dashboard accounting promo banner clicked',
    accountingModalSubmited: 'xxx - iam - dashboard accounting promo modal submitted',
    eInvoicingCtaActivateForFreeClicked: 'xxx - e-invoicing: Clicked "Activate for Free" (Client)',
  },
  debug: {
    oopsScreen: 'xxx - iam - oops error 2024',
    invoiceCreation: 'xxx - iam - contact sync error',
    networkError: 'xxx - api network error',
    blockedInvoiceSending: 'xxx - sales - blocked invoice sending',
    methodNotAllowedError: 'xxx - iam - method not allowed',
  },
  draft: {
    add: 'Invoice Draft Created (Client)',
    lockDateError: 'xxx-sales-lockdateerror',
  },
  invoiceCustomise: {
    invoiceCustomised: 'xxx-niki-invoice-customised',
  },
  estimates: {
    add: 'Quote Created (Client)',
    convertToInvoice: 'Quote Converted To Invoice (Client)',
    sent: 'Quote Sent (Client)',
  },
  experiments: {
    freePlan: 'xxx-activation-exp2-free-plan-',
    inCollectionStatus: 'xxx-niki-incollection-usage',
    invoiceEditorSettingsChanged: 'xxx-niki-invoice-editor-settings-changed',
    welcomeModal: 'xxx-activation-exp3-welcome-modal-',
    goToAccountingClickedNavbar: 'xxx - supernavigation - clicked (Client)',
    goToAccountingClickedTab: 'xxx - accounting navigating clicked (Client)',
  },
  invoice: {
    add: 'Invoice Approved (Client)',
    invoiceFieldsFilled: 'xxx-signe-invoice-fields-filled',
    externalContactIdMissing: 'xxx-sales-externalcontactid-missing',
    sent: 'Invoice Sent (Client)',
    downloaded: 'Invoice Downloaded (Client)',
    attachFiles: 'xxx-adi-send invoice with attachment files 2',
    showInvoiceDocument: 'XXX - Invoicing Core - Show Invoice Document Button Clicked',
  },
  invoiceDraftPreviewPage: {
    finalizeActions: 'XXX - Invoicing Core - finalizing invoice',
  },
  invoiceInfo: {
    approvedInvoiceActions: 'XXX - Invoicing Core - Approved Invoice Action Clicked',
  },
  invoiceLine: {
    description: 'xxx-adi-invoice-line-description',
  },
  loader: {
    syncStart: 'xxx - iam - accounting sync started',
    newTimeout: 'xxx - iam - accounting sync timeout',
    syncOver: 'xxx - iam - accounting sync completed',
  },
  organization: {
    created: 'Organization Created (Client)',
  },
  product: {
    add: 'Product Created (Client)',
    deleted: 'Product Deleted (Client)',
    edit: 'Product Updated (Client)',
  },
  subscription: {
    pricingViewed: 'xxx - iam - pricing viewed',
    pricingCompleted: 'xxx - iam - pricing completed',
    checkoutViewed: 'xxx - iam - checkout viewed',
    checkoutCompleted: 'xxx - iam - checkout completed',
    purchaseCompleted: 'xxx - iam - purchase completed',
    captchaError: 'xxx - iam - captcha error',
  },
  editorSettings: {
    downPayment: {
      downPaymentCheckboxClicked: 'XXX - Invoicing Core - Zervant - Down payment clicked',
      editDownPaymentClicked: 'XXX - Invoicing Core - Zervant - Down payment - Edit down payment request clicked',
      sameInvoiceOptionClicked: 'XXX - Invoicing Core - Zervant - Down payment - same invoice clicked',
      separateAdvanceInvoiceClicked: 'XXX - Invoicing Core - Zervant - Down payment - separate advance invoice clicked',
      percentageToggleClicked: 'XXX - Invoicing Core - Zervant - Down payment - percentage clicked',
      currencyToggleClicked: 'XXX - Invoicing Core - Zervant - Down payment - currency clicked',
    },
    discount: {
      discountCheckboxClicked: 'XXX - Invoicing Core - Zervant - Discount editor - Discount clicked',
      perTotalToggleClicked: 'XXX - Invoicing Core - Zervant - Discount editor - Invoice total clicked',
      perLineToggleClicked: 'XXX - Invoicing Core - Zervant - Discount editor - Invoice line clicked',
      percentageToggleClicked: 'XXX - Invoicing Core - Zervant - Discount editor - % clicked',
      currencyToggleClicked: 'XXX - Invoicing Core - Zervant - Discount editor - currency clicked',
      excludingVatToggleClicked: 'XXX - Invoicing Core - Zervant - Discount editor - excluding vat clicked',
      includingVatToggleClicked: 'XXX - Invoicing Core - Zervant - Discount editor - including vat clicked',
    },
  },
}
